const originalWarn = console.warn;

console.warn = (...args) => {

  if (
    typeof args[0] === 'string' &&
    args[0].includes('[Vue Router warn]: Alias') &&
    args[0].includes('must have the exact same param named')
  ) {

    return;
  
  }
  originalWarn(...args);

};

export default defineNuxtPlugin(() => {
  // Plugin is just here to execute the top-level code that mutates console.warn globally
});
